import {
  flattenMessagePages,
  useConversationByOrderId,
  useConversationMessages,
  useSessionUser,
} from "@web-app/api";
import { Button } from "@web-app/components";
import useDispatchStore from "@web-app/store/dispatchStore";
import { Order, User } from "@web-app/types";

import ChatMessages from "../../../chatPage/ChatMessages";

interface OrderChatHistoryTabProps {
  assignee?: User | null;
  order: Order;
}

export default function OrderChatHistoryTab({
  assignee,
  order,
}: OrderChatHistoryTabProps) {
  const { data: currentUser } = useSessionUser();
  const { data: conversation } = useConversationByOrderId(order.id);

  const {
    data: messagesData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useConversationMessages(conversation?.conversation.id || null);
  const messages = flattenMessagePages(messagesData);

  const driverParticipant = conversation?.participantsWithDetails.find(
    (p) => p.role === "DRIVER",
  );

  const driverName =
    driverParticipant?.name || assignee?.name || "No driver assigned";
  const driverImage = driverParticipant?.image || assignee?.image || "";

  const handleOpenConversation = () => {
    useDispatchStore.setState({
      activeChatConversationId: null,
      activeChatDriverId: order.assigneeId,
      isChatPanelOpen: true,
      pendingChatDriverImage: assignee?.image || null,
      pendingChatDriverName: assignee?.name || null,
      pendingChatOrderDisplayId: order.displayId,
      pendingChatOrderId: order.id,
      pendingChatUserId: order.assigneeId,
    });
  };

  return (
    <div className="flex flex-col h-[calc(100vh-140px)]">
      <div className="flex-1 min-h-0 bg-white">
        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <p className="text-gray-400">Loading messages...</p>
          </div>
        ) : messages.length === 0 ? (
          <div className="flex items-center justify-center h-full">
            <p className="text-gray-400">No messages yet</p>
          </div>
        ) : (
          <ChatMessages
            className="!bg-white h-full"
            messages={messages}
            currentUserId={currentUser?.id || ""}
            currentUserImage={currentUser?.image}
            currentUserName={currentUser?.name || ""}
            otherPartyImage={driverImage}
            otherPartyName={driverName}
            hasMoreMessages={!!hasNextPage}
            isLoadingMore={isFetchingNextPage}
            onLoadMore={fetchNextPage}
          />
        )}
      </div>

      {order.assigneeId && (
        <div className="flex-shrink-0 p-4 bg-white border-t">
          <Button
            onClick={handleOpenConversation}
            className="w-full justify-center"
          >
            Open the conversation
          </Button>
        </div>
      )}
    </div>
  );
}
